module.exports = "//static.hsappstatic.net/salesImages/static-1.403/logos/slack.svg"